import React, { useState, useEffect } from "react";
import { Tabs } from "@mui/material";
import CollegeContainer from "../../Container/CollegeContainer";
import { connect } from "react-redux";
import FormDropdown from "../../../Components/FormField/FormDropdown";
import { teacherLevel } from "../../../Helper";
import { notify } from "react-notify-toast";
import { API } from "../../../API";

const BudgetSetting = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [maximumSpend, setMaximumSpend] = useState("");
  const [action, setAction] = useState("");
  const user = JSON.parse(JSON.parse(window.localStorage['persist:root']).college)?.user;

  const tabs = [
    {
      text: "Campus",
      pathname: "/Campus",
    },
    {
      text: "Personnel",
      pathname: "/Personnel",
    },
    {
      text: user?.is_childcare_centre ? "Shifts" : "Timetable",
      pathname: "/TimeTable",
    },
    {
      text: "Finance Settings",
      pathname: "/FinanceSetting",
    },
    {
      text: "Budget Settings",
      pathname: "/BudgetSetting",
      active: true,
    },
  ];

    useEffect(() => {
      API.getInstitutionDataById(user?.institution_id)
        .then((res) => {
          const inst = res?.data;
          if (inst?.budget) {
            setMaximumSpend(inst?.budget?.maximum_spend)
            setAction(inst?.budget?.action)
          }
        })
        .catch(err => {
          console.log('err', err)
        })
    }, []);

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      const budgetData = {
        maximum_spend: maximumSpend,
        action
      }

      await API.updateBudgetInstitution(user?.institution_id, budgetData)

      notify.show("Update budget successfully!")
      window.location.reload()
      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      console.error(error, 'error updating')
    }
  }

  return (
    <CollegeContainer header="Budget Settings"
      tabs={tabs}
      tabPairs={[]}
      initialIndex={0}
    >
      <Tabs
        value={0}
        fullWidth
        TabIndicatorProps={{
          style: { background: "#34F1C8", color: "#34F1C8" }
        }}
        textColor={'primary'}
      >
        <div className="container college-info">
          <p className="font-17" style={{whiteSpace: "normal"}}>
            ReadyTeacher classifies ten (10) Australian pay levels into four (4) categories for the purposes of simplifying the classification process
            and accelerating teachers’ readiness for work. Here are the four categories below:
          </p>
          <div className="ml-2 mt-2">
            <p className="font-bold font-12">
              Junior: Steps 3-4, paid at level 4
            </p>
            <p className="font-bold font-12">
              Senior: Steps 5-7, paid at level 7
            </p>
            <p className="font-bold font-12">
              Expert: Steps 8-10, paid at level 10
            </p>
            <p className="font-bold font-12">
              Master: Steps 11-12, paid at level 12
            </p>
          </div>
          <p className="font-12">Please note: Settings do not apply when there is an enterprise agreement / Award is not followed</p>
          <div className="mt-2">
            <FormDropdown
              label="My maximum spend is:"
              id="maximum_spend"
              className="col-md-6 px-0"
              required
              value={maximumSpend}
              onChange={(e) => setMaximumSpend(e.target.value)}
            >
              <option value="">Please Choose</option>
              <option value={teacherLevel.JUNIOR}>Junior</option>
              <option value={teacherLevel.SENIOR}>Senior</option>
              <option value={teacherLevel.EXPERT}>Expert</option>
              <option value={teacherLevel.MASTER}>Master</option>
            </FormDropdown>
          </div>
          <div className="mt-2">
            <FormDropdown
              label="When no teacher is available at/below my budget, i would like ReadyTeacher to:"
              id="action"
              className="col-md-6 px-0"
              required
              value={action}
              disabled={maximumSpend === teacherLevel.MASTER}
              onChange={(e) => setAction(e.target.value) }
            >
              <option value="" hidden>Please Choose</option>
              <option value="mark_the_booking_as_none_available">Mark the booking as 'none available'</option>
              <option value="send_a_higher_category_teacher">Send a higher category teacher</option>
            </FormDropdown>
          </div>

          <button
            disabled={isSubmitting}
            type="button"
            onClick={handleSubmit}
            className="btn btn-primary btn-block primary-button-no-margin-hover btn-c button-component"
          >
            {isSubmitting ? 'Submitting...' : 'Submit'}
          </button>
        </div>
      </Tabs>
    </CollegeContainer>
  );
}

export default connect(null, null)(BudgetSetting);